import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { UpdateImmigrationItemTemplate } from 'works/graphql/works-list-item-template';
import DocumentTemplateForm from './document-template-form';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function EditImmigrationTemplate({ dismiss, item, form }) {
  const handleMutationCompletion = (response) => {
    if (response.updateImmigrationItemTemplate.errors) {
      addErrorsToForm(form, response.updateImmigrationItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item updated!');
      dismiss();
    }
  };

  const [updateImmigrationTemplate] = useMutation(
    UpdateImmigrationItemTemplate,
    {
      onCompleted: handleMutationCompletion,
      onError: () =>
        createMessage(
          'error',
          'Failed to update Compliance Item. Please try again.'
        ),
    }
  );

  const handleSubmit = (values) => {
    updateImmigrationTemplate({
      variables: {
        itemId: item.id,
        input: values,
      },
    });
  };

  const initialValues = {
    documentTemplateId: item.documentTemplate.id,
    documentTemplateSubtype: item.documentTemplateSubtype,
    active: item.active,
    name: item.name,
    description: item.description,
    expirationType: item.expirationType,
    daysToExpiry: item.daysToExpiry,
  };

  return (
    <DocumentTemplateForm
      categories={['immigration']}
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      showExpiration
      form={form}
    />
  );
}

EditImmigrationTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};
